import * as React from 'react';
import { SVGProps } from 'react';

const SvgInformation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M19.833 29.667a7.667 7.667 0 1 0 0-15.333 7.667 7.667 0 0 0 0 15.333Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M27.5 7.167h1.333c1.5 0 2.5 1.166 2.5 2.5V34c0 1.5-1.166 2.5-2.5 2.5h-18c-1.5 0-2.5-1.167-2.5-2.5V9.833c0-1.5 1.167-2.5 2.5-2.5h3.834"
    />
    <path fill={props.fill} d="M27.5 8.5v-5l-10.167-.167L12.167 8.5H27.5Z" />
    <path
      fill="currentColor"
      d="M20 17.167c.833 0 1.5.666 1.5 1.5 0 .833-.667 1.5-1.5 1.5s-1.5-.667-1.5-1.5c0-.834.667-1.5 1.5-1.5Zm-1.333 3.5h2.5v6h-2.5v-6Z"
    />
  </svg>
);

export default SvgInformation;
